import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from '@tanstack/react-router'
import { Loader2Icon } from 'lucide-react'
import { Button } from 'ui/button'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { MobileBottomLayout } from '~/layout/mobile-bottom'
import { Route } from '~/routes/_main-layout/settings/subscription/change-payment-method-success'

export const ChangePaymentMethodSuccessPage = () => {
  const { setup_intent, setup_intent_client_secret, redirect_status } = Route.useSearch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isError, setIsError] = useState(redirect_status !== 'succeeded')
  const { pathname } = useLocation()

  const isSamePage = pathname === '/settings/subscription/change-payment-method-success'
  useEffect(() => {
    if (redirect_status !== 'succeeded' || !isSamePage) return

    // TODO: fix UI bug on mobile for the loading state
    const confirmSetupIntent = async () => {
      try {
        const result = await apiClient.POST('/subscription/change-payment-method/complete', {
          body: {
            setup_intent,
            setup_intent_client_secret,
          },
        })

        if (!result.response.ok) return setIsError(true)

        toast.success(t('Payment method updated successfully'))

        await navigate({ to: '/settings/subscription/usage' })
      } catch (error) {
        toast.error(t('Network error'))
        console.error({ message: 'Network error', error })
        setIsError(true)
        return
      }
    }

    void confirmSetupIntent()
  }, [navigate, isSamePage, redirect_status, setup_intent, setup_intent_client_secret, t])

  if (isError)
    return (
      <MobileBottomLayout>
        <h1 className="text-center text-lg font-bold">{t('Change Payment Method Failed')}</h1>
        <Button>
          <Link to="/settings/subscription/usage">{t('Back to subscription page')}</Link>
        </Button>
      </MobileBottomLayout>
    )

  // TODO: send setup_intent to the api and update subscription default payment method

  return (
    <MobileBottomLayout>
      <h1 className="text-center text-lg font-bold">{t('Please wait while we updating your payment method')}</h1>
      <div className="relative h-20">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden">
          <Loader2Icon className="size-20 animate-spin" />
        </div>
      </div>
    </MobileBottomLayout>
  )
}
